/**
 * Message for a rejected API call, falling back when the server sent no body.
 * Use this with api-client methods that let their errors propagate.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const response = (error as {
    response?: { status?: number; data?: { message?: string; error?: string } | string };
  })?.response;
  const data = response?.data;
  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message !== "") {
      return data.message;
    }
    if (typeof data.error === "string" && data.error !== "") {
      return data.error;
    }
  }
  if (response?.status === 404) {
    return "Annotations are not available on this API (HTTP 404). Restart or redeploy the API with the annotations routes.";
  }
  if (response?.status === 503) {
    return "Annotations tables are missing. From sct-api run: soda migrate";
  }
  return fallback;
}
